import React from 'react';

interface SpinnerProps {
    message?: string;
    className?: string;
}

/** A centred spinner that fills the width of its parent. */
const Spinner: React.FC<SpinnerProps> = ({message, className}) => {
    return (
        <div
            className={`w-100 d-flex justify-content-center align-items-center p-5 ${className ?? ''}`}
        >
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            {message && <div className="ms-3">{message}</div>}
        </div>
    );
};

/** Alias used where a whole page or panel is loading. */
export const LoadingBlock = Spinner;

export default Spinner;
